<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<h4 class="application-title">Opportunities</h4>

@if (dataSource) {
  <div class="card">
    <!-- #####################################################################################################################################-->
    <!-- Opportunities Card - Filters Section -->
    <!-- #####################################################################################################################################-->
    <div class="card-body" [formGroup]="opportunitiesForm">
      <div id="agency-filter-area" class="my-3">
        <!--  <div class="w-2/3">-->
        <div class="grid grid-cols-3 gap-x-12">
          <!-- #####################################################################################################################################-->
          <!-- First Row In Opportunities Card: 'Region Dropdown' -->
          <!-- #####################################################################################################################################-->
          <mat-form-field class="no-error-padding">
            <mat-label class="font-medium">Filter by Region</mat-label>
            <mat-select id="region-dropdown" class="option-dropdown" formControlName="region" (selectionChange)="filterByRegion($event)" [(ngModel)]="opportunityFilters.regionId">
              <mat-option [value]="0">(All Regions)</mat-option>
              <span class="option-dropdown">
                @for (region of oppRegions; track region.id) {
                  <mat-option [value]="region.id">{{ region.name }}</mat-option>
                }
              </span>
            </mat-select>
          </mat-form-field>
          <!-- #####################################################################################################################################-->
          <!-- First Row In Opportunities Card: 'License Type Dropdown' & 'Clear Filters' Button -->
          <!-- #####################################################################################################################################-->
          <mat-form-field class="no-error-padding">
            <mat-label class="font-medium">License Types</mat-label>
            <mat-select id="licenseType-dropdown" class="form-control" formControlName="licenseType" (selectionChange)="filterByLicenseType($event)" [(ngModel)]="opportunityFilters.licenseId">
              <mat-option [value]="0">(All Licenses)</mat-option>
              @for (licenseType of oppLicenseTypes; track licenseType.id) {
                <mat-option [value]="licenseType.id"> {{ licenseType.description }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!--  Clear Filters Button -->
          <div class="text-right">
            @if (filterOn) {
              <button mat-raised-button (click)="clearFilters()" aria-label="Clear Filters" aria-labelledby="Clear Filters" class="clearFilters-button font-normal">Clear Filters</button>
            }
          </div>
          <!-- #####################################################################################################################################-->
          <!-- Second Row In Opportunities Card: 'Agency Dropdown' -->
          <!-- #####################################################################################################################################-->
          <mat-form-field class="col-start-1 no-error-padding">
            <mat-label class="font-medium">Filter by Agency</mat-label>
            <mat-select id="agency-dropdown" class="form-control" formControlName="agency" (selectionChange)="filterByAgency($event)" [(ngModel)]="opportunityFilters.agencyId">
              <mat-option [value]="0">(All Agencies)</mat-option>
              @for (agency of oppAgencies; track agency.id) {
                <mat-option [value]="agency.id"> {{ agency.name }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- #####################################################################################################################################-->
          <!-- Second Row In Opportunities Card: 'Search Input Box' -->
          <!-- #####################################################################################################################################-->
          <mat-form-field class="no-error-padding">
            <mat-label class="font-medium">Search Opportunities</mat-label>
            <input matInput class="w-full" formControlName="searchQuery" type="text" placeholder="Search for opportunities here" aria-label="input search opportunities" [(ngModel)]="opportunityFilters.searchQuery" (keyup)="searchOpportunity()" />
          </mat-form-field>
        </div>
        <!-- #####################################################################################################################################-->
        <!-- Third Row In Opportunities Card:  Table Header & Columns -->
        <!-- #####################################################################################################################################-->
        @if (!loadingAllApps) {
          <div class="w-full">
            <table mat-table matSort matSortDisableClear="true" class="shadow-md w-16" matSortActive="prequalDue" matSortDirection="asc" [dataSource]="dataSource">
              <!-- Opp# Column -->
              <ng-container matColumnDef="oppNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="oppNumber">Opp#</th>
                <td mat-cell *matCellDef="let opp" class="cursor-pointer hover:bg-gray-100 hover:underline matCellValue" (click)="onSelectOpp(opp)"><span class="mobile-label">Opp#:</span> {{ opp?.oppNumber }}</td></ng-container
              >
              <!-- Agency Name Column -->
              <ng-container matColumnDef="agencyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="agencyName">Agency Name</th>
                <td mat-cell *matCellDef="let opp" class="cursor-pointer"><span class="mobile-label">Agency Name:</span> {{ opp?.agencyName }}</td>
              </ng-container>
              <!-- Project Name Column -->
              <ng-container matColumnDef="oppName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="oppName">Project Name</th>
                <td mat-cell *matCellDef="let opp"><span class="mobile-label">Project Name:</span> {{ opp?.oppName }}</td>
              </ng-container>
              <!-- Submission Cut Off Date Column -->
              <ng-container matColumnDef="submissionCutOffDate">
                <div class="text-left">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="prequalDue">Submission <br />Cutoff Date</th>
                </div>
                <td mat-cell *matCellDef="let opp"><span class="mobile-label">Submission Cut Off Date:</span> {{ opp?.prequalDue | customDate: 'MM/dd/yyyy' }}</td>
              </ng-container>
              <!-- Bid Date -->
              <ng-container matColumnDef="bidDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="responsibleBiddersDate">Bid Date</th>
                <td mat-cell *matCellDef="let opp"><span class="mobile-label">Bid Date:</span>{{ opp?.responsibleBiddersDate | customDate: 'MM/dd/yyyy' }}</td>
              </ng-container>
              <!-- Licenses Required to Prequalify Column -->
              <ng-container matColumnDef="licenseReqTtoPrequal">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="cslbLicenses">
                  <div class="text-left">Licenses Required <br />to Prequalify</div>
                </th>
                <!---   Adding Plus sign-->
                <td mat-cell *matCellDef="let opp">
                  @for (cslbLicenses of opp.cslbLicenses; track cslbLicenses.code; let i = $index) {
                    <span>
                      <!--If there are 4 or fewer cslbLicenses, just list them. No tool-tip link.-->
                      <!-- <span *ngIf=" ((i < 4 && opp.cslbLicenses.length <= 4) || (i < 3 && opp.cslbLicenses.length > 4))"> -->
                      <span class="mobile-label">Licenses:</span>
                      <span>
                        {{ cslbLicenses.code }}
                        @if (i < opp.cslbLicenses.length - 1) {
                          <span>,</span>
                        }
                        <!-- <br /> -->
                      </span>
                    </span>
                  }
                </td>
              </ng-container>
              <!-- Job Walk Column -->
              <ng-container matColumnDef="jobWalks">
                <div class="flex flex-wrap">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="">
                    <div class="text-left">Job Walk <br /><span class="familyFontSize">(M)=Mandatory</span></div>
                  </th>
                  <td mat-cell *matCellDef="let opp">
                    @for (jobwalk of opp.jobWalks; track $index) {
                      @if (jobwalk.mandatory) {
                        <div>
                          <ul>
                            <span class="mobile-label">Job Walk:</span>
                            <li>{{ '(M)' }} {{ jobwalk.dateTime | customDate: 'MM/dd/yyyy, h:mm a' }}</li>
                          </ul>
                        </div>
                      }
                      @if (!jobwalk.mandatory) {
                        <div>
                          <ul>
                            <span class="mobile-label">Job Walk:</span>
                            <li>{{ jobwalk.dateTime | customDate: 'MM/dd/yyyy, h:mm a' }}</li>
                          </ul>
                        </div>
                      }
                    }
                  </td>
                </div>
              </ng-container>
              <!-- Prequal Status Column -->
              <ng-container matColumnDef="prequalStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="" [hidden]="!loggedInVendor">Status</th>
                <td mat-cell *matCellDef="let opp" [hidden]="!loggedInVendor" class="prequal-status-cell">
                  <!-- LAUSD -->
                  <ng-container *ngIf="environment.site === 'lausd'; else nonLausd">
                    <span class="mobile-label">Status:</span>
                    <a [ngClass]="opp.prequalStatus === 'Get Prequalified' ? 'prequalStatus' : ''" tabindex="0" role="link" (click)="onSelectedPrequalStatus(opp)" (keyup.enter)="onSelectedPrequalStatus(opp)">{{ opp?.prequalStatus }}</a>
                  </ng-container>

                  <!-- NON-LAUSD -->
                  <ng-template #nonLausd>
                    <span class="mobile-label">Status:</span>
                    <!-- Approved/Rated -->
                    <button *ngIf="opp.prequalStatus === 'Approved' || opp.prequalStatus === 'Rated'" mat-icon-button matTooltip="{{ opp.isCUPCCAA ? 'You are Listed and ready for this Opportunity!' : 'You are Prequalified for this Opportunity!' }}" (click)="onSelectedPrequalStatus(opp)" (keyup.enter)="onSelectedPrequalStatus(opp)" class="flex h-10 w-10 items-center justify-center mx-auto">
                      <mat-icon class="verified-check">verified</mat-icon>
                    </button>

                    <!-- In Progress -->
                    <a *ngIf="opp.prequalStatus === 'In Progress'" tabindex="0" role="link" class="prequalStatus" (click)="onSelectedPrequalStatus(opp)" (keyup.enter)="onSelectedPrequalStatus(opp)"> In Progress </a>

                    <!-- Needs prequalification -->
                    <a *ngIf="opp.prequalStatus === 'Get Prequalified'" class="prequalStatus" tabindex="0" role="link" (click)="onSelectedPrequalStatus(opp)" (keyup.enter)="onSelectedPrequalStatus(opp)">
                      @if (opp.isCUPCCAA) {
                        Get Listed
                      } @else {
                        Get Prequalified
                      }
                    </a>

                    <!-- Not required / fallback -->
                    <span *ngIf="opp.prequalStatus !== 'Approved' && opp.prequalStatus !== 'Rated' && opp.prequalStatus !== 'In Progress' && opp.prequalStatus !== 'Get Prequalified'">
                      {{ opp.prequalStatus }}
                    </span>
                  </ng-template>
                </td>
              </ng-container>
              <!-- Subscribe Column -->
              <ng-container matColumnDef="subscribe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="userSubscribed" [hidden]="!loggedInVendor" class="w-10">
                  <span style="margin-left: 10%">Subscribe</span>
                </th>
                <td mat-cell *matCellDef="let opp; let i = index" [hidden]="!loggedInVendor" class="w-10">
                  <!-- Subscribe Bell Icon  -->
                  @if (!opp.userSubscribed) {
                    <img [src]="qbBellOffIcon" class="bellIcon center" (click)="changeSubscription(opp, 'subscribed')" />
                  }
                  <!-- Unsubscribe Bell Icon  -->
                  @if (opp.userSubscribed) {
                    <img [src]="qbBellOnGreenIcon" class="bellIcon center" (click)="changeSubscription(opp, 'unsubscribed')" />
                  }
                </td>
              </ng-container>
              <!-- Area -->
              <ng-container matColumnDef="area">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="regionName" [hidden]="loggedInVendor">Area</th>
                <td mat-cell *matCellDef="let opp" [hidden]="loggedInVendor"><span class="mobile-label">Area:</span>{{ opp.regionName }}</td>
              </ng-container>
              <!-- Status -->
              <!-- <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="" [hidden] = "!loggedInAgency">Status</th>
                <td mat-cell *matCellDef="let opp" [hidden] = "!loggedInAgency"> status </td>
              </ng-container> -->
              <!-- Icon -->
              <!-- <ng-container matColumnDef="icon">
              <div class="text-center">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="" [hidden] = "!loggedInAgency">
                  <img src="../../assets/qb-bell-on-gray.png" class="w-7 h-5"></th>
                  <td mat-cell *matCellDef="let opp" [hidden] = "!loggedInAgency"> 0 </td></div>
                </ng-container> -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover:bg-gray-100"></tr>
              <!-- #####################################################################################################################################-->
              <!-- Row shown when there is no matching data. -->
              <!-- #####################################################################################################################################-->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="10">
                  <em>
                    There are currently no opportunities to display.
                    <span class="link" (click)="clearFilters()">(Clear Filters)</span>
                  </em>
                </td>
              </tr>
            </table>
            <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" aria-label="Select page"> </mat-paginator>
          </div>
        } @else {
          <div class="p-6">
            @if (loadingAllApps) {
              <mat-progress-spinner class="m-auto" color="primary" diameter="50" mode="indeterminate" aria-label="Loading..."></mat-progress-spinner>
            } @else {
              There are currently no opportunities to display.
            }
          </div>
        }
        <!-- #####################################################################################################################################-->
        <!-- End of Table -->
        <!-- #####################################################################################################################################-->
      </div>
    </div>
  </div>
}
